module.exports = __webpack_public_path__ + "static/media/pioneer1.c9699ced.jpg";